import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';
import { selectSizeA, selectSizeB, selectSizeC, selectShowInvalids } from '@store/order/selectors';
import { setSizeA, setSizeB, setSizeC } from '@store/order/slice';
import dogDimensionsFull from '@assets/images/order-dog-dimensions-full.svg';
import NumberField from '@components/text-field/NumberField';
import { invalidFormValue } from '@components/utils';



const DimensionsSection = () => {
	const { t } = useTranslation([ 'forms', 'links' ]);

	const sizeA = useSelector(selectSizeA);
	const sizeB = useSelector(selectSizeB);
	const sizeC = useSelector(selectSizeC);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateSizeA = (value: number | null) => dispatch(setSizeA(value));
	const updateSizeB = (value: number | null) => dispatch(setSizeB(value));
	const updateSizeC = (value: number | null) => dispatch(setSizeC(value));

	return (
		<div className='dimensions-section'>
			
			<div className='dimensions-image'>
				<div className='dimensions-labels'>
					<p><span>A</span>{t('animalInfo.dimensions.imageDogA')}</p>
					<p><span>B</span>{t('animalInfo.dimensions.imageDogB')}</p>
					<p><span>C</span>{t('animalInfo.dimensions.imageDogC')}</p>
				</div>
				<img src={dogDimensionsFull} alt='animal-dimensions-image' />
			</div>
			
			<label className='dimensions-label'>
				{t('animalInfo.dimensions.sectionLabel') + ' '}<span>*</span>
			</label>
		
			<div className='dimensions-inputs'>
				
				<NumberField
					label='A'
					placeholder={t('units.dimensionUnit')}
					valueUnits={t('units.dimensionUnit')}
					rounded={true}
					value={sizeA}
					allowDecimal={false}
					maxNumber={1000}
					onChange={updateSizeA}
					errorMessage={showInvalids && invalidFormValue(sizeA) ? t('validation.requiredField') : undefined} />
				
				<NumberField
					label='B'
					placeholder={t('units.dimensionUnit')}
					valueUnits={t('units.dimensionUnit')}
					rounded={true}
					value={sizeB}
					allowDecimal={false}
					maxNumber={1000}
					onChange={updateSizeB}
					errorMessage={showInvalids && invalidFormValue(sizeB) ? t('validation.requiredField') : undefined} />
				
				<NumberField
					label='C'
					placeholder={t('units.dimensionUnit')}
					valueUnits={t('units.dimensionUnit')}
					rounded={true}
					value={sizeC}
					allowDecimal={false}
					maxNumber={1000}
					onChange={updateSizeC}
					errorMessage={showInvalids && invalidFormValue(sizeC) ? t('validation.requiredField') : undefined} />
			</div>


			<p>{t('animalInfo.dimensions.warning')}</p>

			<p className='dimensions-link'>{t('animalInfo.dimensions.videoText') + ' '}
				<Link to={t('video.dimensionsHowTo', { ns: 'links' })} className='disable-selection' target='_blank'>
					{t('animalInfo.dimensions.videoLabel')}
				</Link>.
			</p>

		</div>
	);
};

export default memo(DimensionsSection);